import { useState } from 'react';

import isEqualLabelResourceRoleSubject from '../libs/isEqualLabelResourceRoleSubject';
import { LabelResourceRoleSubject } from '../types';

export default function useLabelResourceRoleSet(initialRoles?: LabelResourceRoleSubject[]) {
  const [roles, setRoles] = useState(initialRoles || []);

  return {
    add: (value: LabelResourceRoleSubject | LabelResourceRoleSubject[]) => {
      setRoles((roles) => {
        let rolesToAdd = Array.isArray(value) ? value : [value];
        rolesToAdd = rolesToAdd.filter(
          // roles에 없었던 것 필터
          (role) => !roles.some((r) => isEqualLabelResourceRoleSubject(r, role))
        );

        return roles.concat(rolesToAdd);
      });
    },
    remove: (value: LabelResourceRoleSubject | LabelResourceRoleSubject[]) => {
      const rolesToRemove = Array.isArray(value) ? value : [value];
      setRoles((roles) => {
        return roles.filter(
          (role) => !rolesToRemove.some((r) => isEqualLabelResourceRoleSubject(r, role))
        );
      });
    },
    set: setRoles,
    roles,
  };
}
